export type GetStartedPlatformState = 'waiting' | 'running' | 'ready' | 'error'

export type GetStartedPlatformStage = 'connected' | 'fetching' | 'enriching' | 'analysing' | 'ready'

export const GET_STARTED_PLATFORM_STAGES: readonly GetStartedPlatformStage[] = [
  'connected',
  'fetching',
  'enriching',
  'analysing',
  'ready',
]

/** Backend row. The service deliberately normalizes this permissive legacy wire shape. */
export interface GetStartedPlatformProgressDto {
  id?: unknown
  integration_id?: unknown
  integration_type?: unknown
  provider_name?: unknown
  platform_name?: unknown
  name?: unknown
  label?: unknown
  status?: unknown
  state?: unknown
  stage?: unknown
  current_stage?: unknown
  progress_stage?: unknown
  retry_url?: unknown
  retryUrl?: unknown
  error_message?: unknown
  error?: unknown
}

export interface GetStartedProgressPayloadDto {
  platforms?: unknown
  data?: unknown
}

/** Opaque only after the feature-owned validator has fenced it to the selected context. */
export interface GetStartedProgressRetryCommand {
  readonly path: string
}

export interface GetStartedPlatformProgressItem {
  id: string
  integrationType: string
  /** Registry i18n key for known providers; null keeps unknown copy backend-derived. */
  nameKey: string | null
  name: string
  /** A real static-catalog key for known providers; null means render no invented mark. */
  logoKey: string | null
  state: GetStartedPlatformState
  activeStage: number
  stages: readonly GetStartedPlatformStage[]
  errorMessage: string
  retryCommand: GetStartedProgressRetryCommand | null
}

export interface GetStartedProgressContext {
  accountId: number | string
  workspaceId: number | string
}
